import React from "react";
import {
    ARTIST_IMAGE_CONTAINER_CLASS,
    CARD_CONTAINER_CLASS,
    LOGO_IMAGE_CONTAINER_CLASS,
} from "./Style";
import { QOUTES_ICON_TEXT } from "./constants";

const BrandsCards = ({ image, brandLogo }) => {
    return (
        <div className={CARD_CONTAINER_CLASS}>
            <img
                src={image?.url}
                className={ARTIST_IMAGE_CONTAINER_CLASS}
                alt={QOUTES_ICON_TEXT}
                id={QOUTES_ICON_TEXT}
                loading="lazy"
            />
            <img
                src={brandLogo?.url}
                className={LOGO_IMAGE_CONTAINER_CLASS}
                alt={QOUTES_ICON_TEXT}
                id={QOUTES_ICON_TEXT}
                loading="lazy"
            />
        </div>
    );
};

export default BrandsCards;
